import axiosInstance from 'utils/axiosInstance';
import { GridData, GridResponse } from '../../../types/type';
import {
  Approval,
  ApprovalFormValues,
  ApprovalGridInfo,
} from '../types/approvalTypes';

export const Getapprovalsgrid = async (filter: GridData) => {
  const { data } = await axiosInstance.post<
    ApiResponse<GridResponse<Approval[]>>
  >('/api/approval/getapprovalsgrid', filter);
  return data.data;
};

export const DeleteApprovel = async (id: number) => {
  const { data } = await axiosInstance.delete<ApiResponse<null>>(
    `/api/approval/RemoveApproval/${id}`,
  );
  return data;
};

export const DeleteApprovelLevel = async (id: number) => {
  const { data } = await axiosInstance.delete<ApiResponse<null>>(
    `/api/approval/RemoveApprovalLevel/${id}`,
  );
  return data;
};

export const GetListApproval = async (type: string) => {
  const { data } = await axiosInstance.get<
    ApiResponse<{ id: string; text: string }[]>
  >(`/api/approval/GetListApproval/${type}`);
  return data.data;
};

export const GetApprovalLevel = async () => {
  const { data } = await axiosInstance.get<
    ApiResponse<{ id: string; text: string }[]>
  >('/api/approval/GetApprovalLevel');
  return data.data;
};

export const GetApprovalType = async () => {
  const { data } = await axiosInstance.get<ApiResponse<null>>(
    '/api/approval/GetApprovalType',
  );
  return data.data;
};

export const UpdateApprovalService = async (
  credentials: ApprovalFormValues,
) => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(
    '/api/approval/UpdateApproval',
    credentials,
  );
  return data;
};

export const GetApprovalById = async (id: number) => {
  const { data } = await axiosInstance.get<ApiResponse<Approval>>(
    `/api/approval/GetApproval/${id}`,
  );
  return data.data;
};

export const approvalLastModification = async () => {
  const { data } = await axiosInstance.get<ApiResponse<ApprovalGridInfo>>(
    '/api/approval/lastModification',
  );
  return data.data;
};

export const removeApprovalLevelService = async (id: number) => {
  const { data } = await axiosInstance.delete<ApiResponse<null>>(
    `/api/approval/RemoveApprovalLevel/${id}`,
  );
  return data;
};
